import { fetchAdministracion } from "../../http-common";

const postComboArea = (filter) => {
  return fetchAdministracion.post(`Area/ListarCombo`, filter);
};

const AreaService = {
  postComboArea,
};

export default AreaService;
